// Third-party
import React from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const CorrelationLegend = ({ className }: Props) => (
  <div className={classNames('correlation-legend', className)}>
    <div className="correlation-scale" />

    <div className="correlation-legend-labels">
      <span className="upperbound">1</span>
      <span className="zero-value">0</span>
      <span className="lowerbound">-1</span>
    </div>
  </div>
);

export default CorrelationLegend;
